import React, { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../store/authSlice';
import { fetchAgentStats } from '../store/agentsSlice';
import socketService from '../services/socket';
import NetworkBackground from './NetworkBackground';
import TopBar from './TopBar';
import CommandPalette from './CommandPalette';
import { NAV_SECTIONS, PLATFORM_NAME, PLATFORM_TAGLINE } from '../config/platformNav';

function Layout({ children }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { stats } = useSelector((state) => state.agents);
  const [paletteOpen, setPaletteOpen] = useState(false);

  useEffect(() => {
    socketService.connect();
    dispatch(fetchAgentStats());

    const onKeyDown = (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        setPaletteOpen((open) => !open);
      }
    };
    window.addEventListener('keydown', onKeyDown);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
      socketService.disconnect();
    };
  }, [dispatch]);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
  };

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <Link to="/" className="logo logo-home" aria-label="Home — Dashboard">
            <img src="/logo.png" alt="" className="logo-image" />
            <div>
              <span className="logo-text">{PLATFORM_NAME}</span>
              <div className="logo-tagline">{PLATFORM_TAGLINE}</div>
            </div>
          </Link>
        </div>

        <nav className="sidebar-nav">
          {NAV_SECTIONS.map((section) => (
            <div className="nav-section" key={section.id}>
              <div className="nav-section-title">{section.title}</div>
              {section.items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                >
                  <span className="nav-item-icon">{item.icon}</span>
                  <span>{item.label}</span>
                  {item.badgeKey === 'agentsOnline' && stats?.online != null && (
                    <span className="nav-item-badge">{stats.online}</span>
                  )}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info" onClick={handleLogout}>
            <div className="user-avatar">
              {user?.username?.charAt(0).toUpperCase()}
            </div>
            <div className="user-details">
              <div className="user-name">{user?.username}</div>
              <div className="user-role">{user?.role}</div>
            </div>
            <span>🚪</span>
          </div>
        </div>
      </aside>

      <main className="main-content">
        <NetworkBackground />
        <div className="main-content-inner">
          <TopBar onOpenPalette={() => setPaletteOpen(true)} />
          {children}
        </div>
      </main>

      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
    </div>
  );
}

export default Layout;
